(() => {
  if (window.mrOnePopupDesign) return;
  const configNode = document.getElementById('mr-one-design-config');
  if (!configNode) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
  window.mrOnePopupDesign = true;
  const campaign = 'd2b60cbb-8b65-4fe3-a055-d043d668967a';
  const words = config.text;
  const done = new WeakSet();
  const resultsDone = new WeakSet();
  const keyboardButtons = new WeakSet();
  const successWords = words.success || {
    eyebrow: "YOU'RE ON THE LIST",
    title: 'Your downloads are ready.',
    description: 'Thanks for joining. Open the download page to get your free resources.',
    items: ['Photoshop editing tutorial', '33 high-resolution wallpapers', 'Photo tour PDFs'],
    button: 'Open download page',
    note: 'Opens in a new tab'
  };
  let lastDialog = null;
  let returnFocus = null;
  const make = (tag, className, text) => {
    const el = document.createElement(tag);
    el.className = className;
    if (text) el.textContent = text;
    return el;
  };
  // ONE can rewrite its Vue-managed class/style attributes after opening.
  // Restore our styling independently of the one-time content enhancement.
  const restoreTheme = (overlay, success = false) => {
    if (!overlay.classList.contains('mr-one-tutorial')) overlay.classList.add('mr-one-tutorial');
    if (overlay.classList.contains('mr-one-success') !== success) overlay.classList.toggle('mr-one-success', success);
    const landscape = `url("${config.landscape}")`;
    if (overlay.style.getPropertyValue('--mr-one-landscape') !== landscape) overlay.style.setProperty('--mr-one-landscape', landscape);
  };
  const keyboardButton = (el, label) => {
    if (!el) return;
    el.setAttribute('role', 'button');
    el.setAttribute('tabindex', '0');
    if (label) el.setAttribute('aria-label', label);
    if (keyboardButtons.has(el)) return;
    keyboardButtons.add(el);
    el.addEventListener('keydown', event => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        el.click();
      }
    });
  };
  const activateDialog = (panel, close, label) => {
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-label', label);
    panel.setAttribute('tabindex', '-1');
    if (!lastDialog) returnFocus = document.activeElement;
    lastDialog = panel;
    panel.addEventListener('keydown', event => {
      if (event.key === 'Escape' && close) { event.preventDefault(); close.click(); }
      if (event.key !== 'Tab') return;
      const targets = Array.from(panel.querySelectorAll('input, button, a[href], [tabindex="0"]')).filter(el => !el.disabled && el.getClientRects().length);
      if (!targets.length) return;
      const first = targets[0];
      const last = targets[targets.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    requestAnimationFrame(() => { if (panel.isConnected && panel.getClientRects().length) panel.focus({ preventScroll: true }); });
  };
  const enhancePopup = overlay => {
    if (!overlay.getAttribute('style')?.includes(campaign)) return;
    const title = overlay.querySelector('.proof-factor-cb-header-title');
    const panel = overlay.querySelector('.proof-factor-cb-prompt-content');
    const aside = overlay.querySelector('.proof-factor-cb-prompt-aside');
    const body = overlay.querySelector('.proof-factor-cb-prompt-body');
    const optin = overlay.querySelector('.proof-factor-cb-prompt-opt-in');
    const form = panel?.querySelector('form');
    if (!title || !panel || !aside || !body || !optin || !form || !/editing\s+tutorial/i.test(title.textContent)) return;
    restoreTheme(overlay);
    if (done.has(panel)) return;
    done.add(panel);
    const cover = make('img', 'mr-one-cover');
    cover.src = config.cover;
    cover.alt = words.coverAlt;
    cover.width = 400;
    cover.height = 400;
    cover.decoding = 'async';
    aside.append(cover);
    title.before(make('div', 'mr-one-eyebrow', words.eyebrow));
    title.textContent = words.title;
    const subtitle = overlay.querySelector('.proof-factor-cb-header-subtitle');
    if (subtitle) subtitle.textContent = words.description;
    const benefits = make('ul', 'mr-one-benefits');
    words.benefits.forEach(text => {
      const row = make('li', '');
      const check = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      check.setAttribute('class', 'mr-one-check');
      check.setAttribute('viewBox', '0 0 20 20');
      check.setAttribute('fill', 'none');
      check.setAttribute('aria-hidden', 'true');
      check.innerHTML = '<circle cx="10" cy="10" r="8" stroke="currentColor" stroke-width="1.3"/><path d="m6 10 2.6 2.6L14 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>';
      row.append(check, make('span', '', text));
      benefits.append(row);
    });
    optin.replaceChildren(benefits);
    const submit = form.querySelector('.proof-factor-cb-subscribe-button');
    if (submit) {
      Array.from(submit.childNodes).filter(n => n.nodeType === 3 && n.textContent.trim()).forEach(n => { n.textContent = words.button; });
      submit.after(make('p', 'mr-one-consent', words.consent));
    }
    const fields = [
      ['.proof-factor-cb-prompt-input-firstname', words.firstName, 'given-name'],
      ['.proof-factor-cb-prompt-input-lastname', words.lastName, 'family-name'],
      ['.proof-factor-cb-prompt-input-email', words.email, 'email']
    ];
    fields.forEach(([selector, label, autocomplete]) => {
      const input = form.querySelector(selector);
      if (!input) return;
      input.setAttribute('aria-label', label);
      input.setAttribute('placeholder', label);
      input.setAttribute('autocomplete', autocomplete);
    });
    const close = body.querySelector('.proof-factor-cb-prompt-close');
    const decline = form.querySelector('.proof-factor-cb-decline-text');
    keyboardButton(close, words.close);
    keyboardButton(decline);
    activateDialog(panel, close, words.title);
  };
  const enhanceSuccess = overlay => {
    if (!overlay.getAttribute('style')?.includes(campaign)) return;
    const panel = overlay.querySelector('.proof-factor-cb-result-content');
    if (!panel) return;
    const body = panel.querySelector('.proof-factor-cb-result-body');
    const aside = panel.querySelector('.proof-factor-cb-result-aside');
    const title = panel.querySelector('.proof-factor-cb-result-title');
    const description = panel.querySelector('.proof-factor-cb-result-description');
    const footer = panel.querySelector('.proof-factor-cb-result-footer');
    const link = footer?.querySelector('a[href]');
    if (!body || !aside || !title || !description || !link) return;
    let destination;
    try { destination = new URL(link.href); } catch (_) { return; }
    // Enhance only this campaign's confirmed download result, never errors or verification screens.
    if (destination.hostname !== 'maxrivephotography.com' || !['/pages/pdf-tour-page', '/pages/tour-pdf'].includes(destination.pathname)) return;
    restoreTheme(overlay, true);
    if (resultsDone.has(panel)) return;
    resultsDone.add(panel);
    const cover = make('img', 'mr-one-success-cover');
    cover.src = config.cover;
    cover.alt = words.coverAlt;
    cover.width = 400;
    cover.height = 400;
    cover.decoding = 'async';
    aside.append(cover);
    const status = make('div', 'mr-one-success-status');
    const check = make('span', 'mr-one-success-check', '✓');
    check.setAttribute('aria-hidden', 'true');
    status.append(check, make('span', '', successWords.eyebrow));
    title.before(status);
    title.textContent = successWords.title;
    description.textContent = successWords.description;
    const resources = make('ul', 'mr-one-success-resources');
    successWords.items.forEach(text => resources.append(make('li', '', text)));
    description.after(resources);
    // Keep the original link, destination, target and ONE click handlers.
    link.classList.add('mr-one-download-link');
    link.textContent = successWords.button;
    if (link.target === '_blank') footer.after(make('p', 'mr-one-success-note', successWords.note));
    const close = body.querySelector('.proof-factor-cb-result-close');
    keyboardButton(close, words.close);
    activateDialog(panel, close, successWords.title);
  };
  const enhanceTeaser = box => {
    const content = box.querySelector('.proof-factor-cb-trigger-corner-content');
    const trigger = box.querySelector('.proof-factor-cb-trigger-corner');
    if (!content || !trigger) return;
    const campaignImage = box.querySelector(`[style*="${campaign}"]`);
    const label = content.querySelector('.proof-factor-cb-trigger-corner-text')?.textContent.replace(/\s+/g, '').toLowerCase();
    const tutorialLabel = label === 'freeeditingtutorial' || label === words.title.replace(/\s+/g, '').toLowerCase();
    if (!campaignImage && (!tutorialLabel || !box.closest('#proof-factor-nl-container'))) return;
    if (!box.classList.contains('mr-one-launcher')) box.classList.add('mr-one-launcher');
    if (content.querySelector('.mr-one-teaser')) return;
    const card = make('div', 'mr-one-teaser');
    card.setAttribute('aria-hidden', 'true');
    const cover = make('img', '');
    cover.setAttribute('loading', 'lazy');
    cover.src = config.thumbnail;
    cover.alt = '';
    cover.width = 270;
    cover.height = 270;
    cover.decoding = 'async';
    const coverPanel = make('div', 'mr-one-teaser-cover');
    coverPanel.append(cover);
    const text = make('span', '');
    text.append(make('small', '', words.teaserEyebrow), make('strong', '', words.teaserTitle));
    card.append(coverPanel, text, make('span', 'mr-one-teaser-arrow', '→'));
    content.append(card);
    keyboardButton(trigger, words.open);
    trigger.setAttribute('aria-haspopup', 'dialog');
  };
  const scan = app => {
    app.querySelectorAll('.proof-factor-cb-overlay').forEach(overlay => {
      enhancePopup(overlay);
      enhanceSuccess(overlay);
    });
    app.querySelectorAll('.proof-factor-cb-trigger-styles-box').forEach(enhanceTeaser);
    if (lastDialog && !lastDialog.isConnected) {
      const focusTarget = returnFocus?.isConnected && returnFocus !== document.body ? returnFocus : app.querySelector('.mr-one-launcher .proof-factor-cb-trigger-corner');
      if (focusTarget) focusTarget.focus({ preventScroll: true });
      lastDialog = null;
    }
  };
  let appObserver;
  const attach = () => {
    const app = document.getElementById('proof-factor-app');
    if (!app) return false;
    scan(app);
    appObserver = new MutationObserver(records => {
      if (records.some(record => record.type !== 'attributes' || record.target.matches('.proof-factor-cb-trigger-corner-content,.proof-factor-cb-trigger-styles-box,.proof-factor-cb-overlay'))) scan(app);
    });
    appObserver.observe(app, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['style', 'class'] });
    return true;
  };
  if (!attach()) {
    const startup = new MutationObserver(() => { if (attach()) startup.disconnect(); });
    startup.observe(document.body, { childList: true });
    setTimeout(() => startup.disconnect(), 120000);
  }
})();
